"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterConfig = void 0;
class FilterConfig {
    constructor(NEW_GAME_PERIOD, UPCOMING_GAME_PERIOD, NUM_RELATED_GAMES, SHOW_GAME_TYPES) {
        this.NEW_GAME_PERIOD = 31;
        this.UPCOMING_GAME_PERIOD = 31;
        this.NUM_RELATED_GAMES = 3;
        this.SHOW_GAME_TYPES = false;
        this.NEW_GAME_PERIOD = NEW_GAME_PERIOD;
        this.UPCOMING_GAME_PERIOD = UPCOMING_GAME_PERIOD;
        this.NUM_RELATED_GAMES = NUM_RELATED_GAMES;
        this.SHOW_GAME_TYPES = SHOW_GAME_TYPES;
    }
}
exports.FilterConfig = FilterConfig;
//# sourceMappingURL=FilterConfig.js.map